import React, { useMemo, useState } from 'react'
import Scroll from 'react-scroll'
import Genres from '../MovieDetails/Genres';
import MovieDetailsContainer from '../MovieDetails'
import Length from '../MovieInformation/Length';
import ItemAttributes from '../PosterFormatItem/ItemAttributes';
import Translation from '../General/Translation';
import Description from '../MovieInformation/Description';
import ShareButtons from '../General/ShareButtons';
import { SiteSlidebarRight, SiteSlidebarRightSecond } from '../General/SiteSlidebars';
import DetailsButton from './FilterResultsList/DetailsButton';
import { trackMovieDetailsClose, trackMovieDetailsOpen, trackMoviePerformanceClose, trackMoviePerformanceOpen } from '../tracking';
import getBackgroundsUrlsObj from '../functions/getBackgroundsUrlsObj';
import getImageUrl from '../functions/getImageUrl';
import TrailerSmall from '../Trailer/TrailerSmall';
import getMoreMovies from '../functions/getMoreMovies';
import BackgroundFormatItemContainer from '../BackgroundFormatItem';
import FskWrapper from '../MovieInformation/FskWrapper';
import MovieTimesContainer from '../MovieInformation/MovieTimesContainer';
import getAttributesDisplaySettings from '../functions/getAttributesDisplaySettings';
import checkPerformanceFilterIsSet from '../functions/checkPerformanceFilterIsSet';
import PerformanceSectionContainer from '../PerformancePage/PerformanceSectionContainer';
import ItemAttributesContainer from '../PosterFormatItem/ItemAttributesContainer';

let Element = Scroll.Element;

const FilterResultsMovieArthouseItem = ({
    activePerformance, 
    activeDetailsItem,
    itemsData, 
    itemData,
    theme, 
    itemLink,
    moviesRoutesData,
    isMobile,
    translation, 
    currentDateActive,
    queryStringValues,
    toggleMovieDatesOnMobileView,
    onOpenIframe,
    routesData, 
    performancePageOpen, 
    displaySidebarRight, 
    displaySidebarRightSecond, 
    onClosePerformancePage, 
    onOpenPerformancePage, 
    onOpenDetails,
    onCloseDetails
}) => {
    if(!itemData) {
        return ''
    }

    const [fallbackInUse, setFallback] = useState(false)
    const {title, images, descriptionShort, fsk, subTitle, length, technologyAttributes, titleDisplay, trailerURL, pk, genres, performances } = itemData
    const headerImages = []
    const currentTitle = titleDisplay ? titleDisplay : title 
    const performanceFilterIsSet = checkPerformanceFilterIsSet(technologyAttributes, null, null, queryStringValues)
    const {noAttributesWithIconsToDisplay, noAttributesToDisplayWithSchnäppchen, noAttributesWithoutIconsToDisplay, technologyAttributesWithoutIcons, technologyAttributesWithIcons} = getAttributesDisplaySettings(technologyAttributes, performances, null, null, queryStringValues, performanceFilterIsSet, translation)
    const moreMovies = getMoreMovies(itemData, itemsData, technologyAttributesWithIcons, technologyAttributesWithoutIcons)
    const detailsOpen = activeDetailsItem === pk
    const eventOrigins = {
        listitem:                 'Programmübersicht, Movie, Filmelement',
        details:                  'Programmübersicht, Movie, Film Details',
        detailsSlidebar:          'Programmübersicht, Movie, Film Details/rechte Slidebar'
    }
    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
    )
    const {currentLang} = translation

    if(images) {
        const {ambient, poster, backgrounds} = images
        if(poster) {
            headerImages.push({
                type: 'poster',
                item: poster
            })
        }
        if(ambient) {
            headerImages.push({
                type: 'ambient',
                item: ambient
            })
        }
        if(backgrounds.length > 0) {
            backgrounds.map(background => {
                if(headerImages.length < 4 && background.url && -1 === headerImages.findIndex(img => img.item.url === background.url)) {
                    headerImages.push({
                        type: 'background',
                        item: background
                    })
                }
            })
        }
    }

    return <>
        <div className='single-movie-information-wrapper'>
            <div className={'images-wrapper grid-' + headerImages.length}>
                {headerImages && headerImages.map((img, index) => {
                    let image = null
                    if(img.type === 'poster') {
                        const {finalImageURl, imageUrl, position} = getImageUrl(img.item, isMobile, true, true)
                        let styles = {    
                            objectPosition: position
                        }

                        image = <img 
                                src={finalImageURl}
                                style={styles}
                                className='movie-item-poster-image theme-radius-posters-full'
                                alt={'Poster'} 
                                onError={({ currentTarget }) => {
                                    if(fallbackInUse) {
                                        currentTarget.onerror = null; 
                                        currentTarget.src = '';
                                    } else {
                                        setFallback(true)
                                        currentTarget.onerror = null; 
                                        currentTarget.src = imageUrl;
                                    }
                                }}
                            />
                    } else {
                        const {finalImageURl, imageUrl, position} = getImageUrl(img.item, isMobile, false, true)
                        let styles = {    
                            objectPosition: position
                        }
                    
                        image = <img 
                                src={finalImageURl} 
                                style={styles}
                                className={'movie-item-background-image theme-radius-posters-full ' + img.type}
                                alt={'Background'} 
                                onError={({ currentTarget }) => {
                                    if(fallbackInUse) {
                                        currentTarget.onerror = null; 
                                        currentTarget.src = '';
                                    } else {
                                        setFallback(true)
                                        currentTarget.onerror = null; 
                                        currentTarget.src = imageUrl;
                                    }
                                }}
                            />
                    }

                    const trailerClass = img.type === "ambient" ? ' trailer-image' : ''

                    return (
                        <div className={'image-wrapper-' + (index + 1) + trailerClass + ' ' + img.type} key={index}>
                            {image && image}
                            {img.type === "poster" && headerImages.length === 1 && <div className='poster-wrapper'>{image}</div>}
                            {img.type === "ambient" && trailerURL && <TrailerSmall
                                trailerURL={trailerURL}
                                fsk={fsk}
                                translation={translation}
                            />} 
                        </div>
                    )
                })}
            </div>
            <div className='information-wrapper'>
                <div className='left-section'>
                    <div className='left'> 
                        <h2 className={'title title-xlarge-bold-overview'}>
                            {currentTitle}
                        </h2>
                        {subTitle && <p className='title-slider subtitle'>{subTitle}</p>}
                        <div className='row-flex-information'>
                            <Genres genres={genres} theme={theme} translation={translation}/>
                            {length && <Length length={length} translation={translation}/>}
                            <FskWrapper fsk={fsk}/>
                        </div>
                        <DetailsButton
                            movieId={pk}
                            movieTitle={currentTitle} 
                            scrollToPosition={pk}
                            translation={translation}
                            itemDetailsOpen={detailsOpen} 
                            openItemDetails={trackMovieDetailsOpen(onOpenDetails, eventOrigins.listitem)} 
                            closeItemDetails={trackMovieDetailsClose(onCloseDetails, eventOrigins.listitem)} 
                        />
                    </div>
                    <div className='right'>
                        <Description movieData={itemData} translation={translation}/>
                    </div>
                </div>
                <div className='right-section'>
                    <div className='attributes-container'>
                        {!noAttributesToDisplayWithSchnäppchen && <p className='text-bold attribute-wrapper-title'><Translation id="availableIn" trans={translation}>Verfügbar in</Translation>:</p>}
                        {!noAttributesWithIconsToDisplay && <div className='attributes-with-icons'>
                            <ItemAttributesContainer attributes={technologyAttributesWithIcons} canBeColored={true} />
                        </div>}
                        {!noAttributesWithoutIconsToDisplay && <div className='attributes-without-icons'>
                            <ItemAttributesContainer attributes={technologyAttributesWithoutIcons} />
                        </div>}
                    </div>

                    {itemLink && <ShareButtons
                        url={itemLink}
                        title={currentTitle}
                        description={descriptionShort}
                        translation={translation}
                    />}
                </div>
            </div>
        </div>
        <div className='single-movie-movie-times'>
            <MovieTimesContainer
                activePerformance={activePerformance}
                movieData={itemData} 
                onClick={toggleMovieDatesOnMobileView}
                additionalClass={' show-on-mobile'}
                currentDateActive={currentDateActive}
                scrollToPosition={pk}
                onOpenIframe={onOpenIframe}
            />
        </div>
        {!displaySidebarRightSecond && performancePageOpen && activePerformance.movieId === pk && <PerformanceSectionContainer
            activeItem={pk}
            activePerformance={activePerformance}
            isMobile={isMobile}
            noMovietimes={true}
            moviesData={itemsData}
            scrollToPosition={pk}
            onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage)}
        />}

        {displaySidebarRightSecond && performancePageOpen && activePerformance.movieId === pk && <SiteSlidebarRightSecond>
            <PerformanceSectionContainer
                isMobile={isMobile}
                queryStringValues={queryStringValues}
                activeItem={pk}
                activePerformance={activePerformance}
                moviesData={itemsData}
                performancePageMovieTimes={true}
                scrollToPosition={pk + ' openMovieInformation'}
                currentDateActive={currentDateActive}
                backgroundImage={backgroundsObj.performance}
                toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.performance)}
                onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage, eventOrigins.performance)}
            />
        </SiteSlidebarRightSecond>}

        <Element name={pk + ' movieDetails'}></Element>

        {!displaySidebarRight && detailsOpen && 
            <MovieDetailsContainer
                itemID={pk}
                queryStringValues={queryStringValues} 
                moviesData={itemsData}
                trailerImage={backgroundsObj.ambient}
                backgroundImage={backgroundsObj.details}
                scrollToPosition={pk}
                onCloseDetails={trackMovieDetailsClose(onCloseDetails, eventOrigins.details)}
                />
            }

        {displaySidebarRight && detailsOpen &&
            <SiteSlidebarRight>
                <div className="site-slidebar-overlay accent-color-background-half-transparent" onClick={onCloseDetails} />

                <div className="site-slidebar-content accent-color-background-half-transparent">
                    <MovieDetailsContainer
                        itemID={pk}
                        moviesData={itemsData}
                        trailerImage={backgroundsObj.ambient}
                        queryStringValues={queryStringValues} 
                        isMobile={isMobile}
                        backgroundImage={backgroundsObj.details}
                        scrollToPosition={pk}
                        onCloseDetails={trackMovieDetailsClose(onCloseDetails, eventOrigins.detailsSlidebar)}
                    />
                </div>

            </SiteSlidebarRight>
        }

        {moreMovies.length !== 0 && <div className='single-movie-more-movies-wrapper'>
            <div className='titles-wrapper'>
                <p className="title-xlarge"><Translation id="moreMovies" trans={translation}>Weitere Filme</Translation></p>
                {routesData && <a className="full-program-button" href={routesData.program_overview[currentLang].uri}>
                    <p><Translation className="full-program-button" id="fullProgram" trans={translation}>Komplettes Programm</Translation></p>
                    <svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.99 11.49">
                        <g id="Ebene_1-2" data-name="Ebene 1">
                            <polygon points="12.33 0 10.78 1.26 13.61 4.75 0 4.75 0 6.75 13.6 6.75 10.78 10.24 12.33 11.49 16.99 5.73 12.33 0"/>
                        </g>
                    </svg>
                </a>}
            </div>
            <div className='single-movie-more-movies no_slide'> 
                {moreMovies.map((movie, index) => { 
                    return <div key={index} className="slide-item">
                        <BackgroundFormatItemContainer
                            itemID={movie.pk}
                            itemData={movie}
                            showPerformances={false}
                            translation={translation}
                            scrollToPosition={movie.pk}
                            isMobile={isMobile}
                            onClickItem={()=>{}}
                            index = {index}
                            queryStringValues={{}}
                            goToMoviepage={true}
                            moviesRoutesData={moviesRoutesData}
                            />
                    </div>
                })}
            </div>
        </div>}
    </>
}



export default FilterResultsMovieArthouseItem